module.exports = __webpack_public_path__ + "img/84.3285ff50.jpg";